import React from 'react';

export default function PhaseNum(props) {
  return (
    <svg width="39px" height="25px" viewBox="0 0 39 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        {/* Generator: Sketch 61.2 (89653) - https://sketch.com */}
        <title>Group 6</title>
      <desc>Created with Sketch.</desc>
      <g id="🖥-Wireframes-Desktop" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Activities-Grid-Prototype-dropdown-activity" transform="translate(-727.000000, -773.000000)">
          <g id="Group-6" transform="translate(727.000000, 773.000000)">
            <path d="M0,12.8958297 C8.54926915,4.29860991 15.0492692,0 19.5,0 C23.9507308,0 30.4507308,4.29860991 39,12.8958297 C30.4348958,20.9652766 23.9348958,25 19.5,25 C15.0651042,25 8.56510417,20.9652766 0,12.8958297 Z" id="Partner" fillOpacity="0.5" fill="rgba(115, 157, 99, .5)" />
            <text x="50%" y="50%" textAnchor="middle" id={12} fontFamily="Inter" fontSize={12} fontWeight={700} line-spacing={16} fill="#0A1F44">
              <tspan y="16.9090909">{props.count}</tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
}
